

export const HOST = 'https://therouseco.com'

const config = {
    HOST
}

export default config